var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowsVertical = function SvgIconArrowsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "m20.7 15.45-2.7 2.7V3h-1.5v15.15l-2.7-2.7-1.05 1.05 4.5 4.5 4.5-4.5zM6.75 3l-4.5 4.5L3.3 8.55 6 5.85V21h1.5V5.85l2.7 2.7 1.05-1.05z"
  })));
};
export default SvgIconArrowsVertical;